<template>
  <div class="y-pd-20">
    <el-table :data="canJoinKList" v-loading="loading">
      <el-table-column label="客户编码">
        <template slot-scope="scope">
          {{ scope.row.customerCode }}-{{ scope.row.customerName }}
        </template>
      </el-table-column>
      <el-table-column label="合作网点" prop="branchName"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="clickHasConnected(scope.row)">已关联店铺</el-button>
          <!-- 只对客户数据绑定中，店铺关联开关是开启状态的显示“新增关联店铺”按钮 -->
          <el-button type="text" @click="connectNewShopDialog(scope.row)" v-if="scope.row.bindSellerStatus === '1'">新增关联店铺</el-button>
        </template>
      </el-table-column>
      <div slot="empty" style="text-align: center;">
        {{ loading ? '正在查询...' : '暂无数据' }}
      </div>
    </el-table>
    <hasConnectedShop :curCustomCode="curCustomCode" :curCustomName="curCustomName" :showConnectedDialog.sync="showConnectedDialog" />
    <addConnectShop
      :curCustomCode="curCustomCode"
      :curCustomName="curCustomName"
      :showNewConnectDialog.sync="showNewConnectDialog" />
  </div>
</template>
<script>
import { getCustomerKListApi } from '@/api/activityCenter/incrementActivity'
export default {
  data() {
    return {
      showConnectedDialog: false,
      showNewConnectDialog: false,
      curCustomCode: '',
      curCustomName: '',
      loading: false,
      canJoinKList: [],
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  methods: {
    getAllowApplyK() {
      // 查询可报名的K码
      this.loading = true;
      getCustomerKListApi({ userId: this.userMess.loginId }).then(res => {
        console.log(res)
        if(res.status === 0) {
          this.canJoinKList = res.data || [];
        } else {
          this.canJoinKList = [];
          this.$message.error(res.message);
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error('服务器错误')
      })
    },
    clickHasConnected(row) {
      this.curCustomCode = row.customerCode;
      this.curCustomName = row.customerName;
      this.showConnectedDialog = true;
    },
    connectNewShopDialog(row) {
      this.curCustomCode = row.customerCode;
      this.curCustomName = row.customerName;
      this.showNewConnectDialog = true;
    }
  },
  mounted() {
    this.getAllowApplyK();
  },
  components: {
    hasConnectedShop: () => import('./hasConnectedShop.vue'),
    addConnectShop: () => import('./addConnectShopDia.vue')
  }
}
</script>
